import {Stack, styled} from '@mui/material';

export const StyledStack = styled(Stack)`
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;

export const StyledContainer = styled(Stack)`
	padding-bottom: 16px;
	border-bottom: 1px solid ${({theme}) => theme.palette.divider};
`;
